/**
*
* RedWorkshop
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import getFrontendHost from 'getFrontendHost';

import setLanguageContent from 'helpers/setLanguageContent';
import Wrapper from 'components/Templates/dynamics/Wrapper';

import defaultTextValues from './defaultTextValues';
import moment from 'moment-timezone';

import selectSpeakerById from 'helpers/selectSpeakerById';
import selectTicketById from 'helpers/selectTicketById';
import selectPresentationById from 'helpers/selectPresentationById';

class RedWorkshop extends React.PureComponent {


  render() {

    const {
      commonData,
      openEditor,
      commonProps,
      ticketsData,
      language,
      presentationsData,
      speakers,
    } = this.props;

    const {
      timezone,
      baseUrlTamplate
    } = commonProps;

    const {
      componentPayload,
      sectionId
    } = commonData;

    const {
      ticketId,
      presentationId,
      companyLogoType
    } = componentPayload;

    const thisCompanyLogoType = companyLogoType ? companyLogoType : 'colorLogo';
    const thisBaseTemplateUrl = baseUrlTamplate ? baseUrlTamplate : '';
 
    let workshopTicketData;

    if (ticketId) {
      workshopTicketData = selectTicketById(ticketsData, ticketId);
    }
    const workshopPresentationData = selectPresentationById(presentationsData, presentationId);

    const speakersContainer = [];
    const companiesList = []

    const logosContent = workshopPresentationData && workshopPresentationData.speakers ? workshopPresentationData.speakers.map((speaker) => {
      const thisSpeaker = selectSpeakerById(speakers, speaker);

      if (!thisSpeaker) return;

      speakersContainer.push(
        <Wrapper
          {...commonProps}
          key={'RedWorkshop-speakerName-'+sectionId+thisSpeaker.speakerId}
          
          typeOfStyle={'speakerName'}
          href={thisBaseTemplateUrl+'/speaker/'+thisSpeaker.slug}
          editorData={
            {
              editorType: 'speakerName',
              ...commonData
            }
          }
        >
          {thisSpeaker ? thisSpeaker.firstName : ''} {thisSpeaker ? ' '+thisSpeaker.lastName : ''}{thisSpeaker.speakerCompany && thisSpeaker.speakerCompany.name ? ', ' + thisSpeaker.speakerCompany.name : ''}
        </Wrapper>
      );

      if (companiesList && thisSpeaker.speakerCompany && !companiesList.includes(thisSpeaker.companieId)) {
        companiesList.push(thisSpeaker.companieId);
        return (
          <Wrapper
          {...commonProps}
          
          key={'RedWorkshop-logo-'+sectionId+thisSpeaker.speakerId}
          typeOfStyle={'logo'}
          backgroundImage={thisSpeaker.speakerCompany && thisSpeaker.speakerCompany[thisCompanyLogoType] ? thisSpeaker.speakerCompany[thisCompanyLogoType] : ''}
          editorData={
            {
              editorType: 'logo',
              ...commonData
            }
          }
        />
        );
      }
    }) : ''

    let start;
    let end;
    let dateString;
    let duration = 0;

    if (workshopPresentationData && workshopPresentationData.dateFrom && workshopPresentationData.dateTo) {
      start = moment(workshopPresentationData.dateFrom).tz(timezone);
      end = moment(workshopPresentationData.dateTo).tz(timezone);
   
      dateString = `${moment(start).format('HH:mm')}-${moment(end).format('HH:mm')},  ${moment(start).format('DD MMM')}`;
  
  
      duration = moment.duration(end.diff(start)).asMinutes();
    }



    return (
      <Wrapper
        {...commonProps}
        
        typeOfStyle={'wrapper'}
        editorData={
          {
            editorType: 'wrapper',
            ...commonData
          }
        }
      >
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'wrapperWithMargin'}
          editorData={
            {
              editorType: 'wrapperWithMargin',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'workshopDate'}
            editorData={
              {
                editorType: 'workshopDate',
                ...commonData
              }
            }
          > {dateString}</Wrapper>

          <Wrapper
            {...commonProps}
            
            typeOfStyle={'durationWrapper'}
            editorData={
              {
                editorType: 'durationWrapper',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'durationHeader'}
              editorData={
                {
                  editorType: 'durationHeader',
                  ...commonData
                }
              }
            >
              {'Duration:'}
            </Wrapper>
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'duration'}
              defaultValues={defaultTextValues}
              editorData={
                {
                  editorType: 'duration',
                  ...commonData
                }
              }
            >
              {`${duration} mins`}
            </Wrapper>
          </Wrapper>
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'title'}
            defaultValues={defaultTextValues}
            editorData={
              {
                editorType: 'title',
                ...commonData
              }
            }
          >
            {setLanguageContent(workshopPresentationData, 'title', language)}
          </Wrapper>
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'description'}
            editorData={
              {
                editorType: 'description',
                ...commonData
              }
            }
          >
            {setLanguageContent(workshopPresentationData, 'description', language)}
          </Wrapper>
          {speakersContainer}
          
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'logoWrapper'}
            editorData={
              {
                editorType: 'logoWrapper',
                ...commonData
              }
            }
          >
            {logosContent}
          </Wrapper>
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'buttonCenterWrapper'}
            editorData={
              {
                editorType: 'buttonCenterWrapper',
                ...commonData
              }
            }
          >
            {
               workshopTicketData && workshopTicketData.ticketId? (
                  <Wrapper
                  {...commonProps}
                  
                  type={'text'}
                  defaultValues={defaultTextValues}
                  typeOfStyle={'workShopBuyButton'}
                  href={workshopTicketData.customUrl ? workshopTicketData.customUrl : getFrontendHost()+'dashboard/checkout/'+workshopTicketData.ticketId}
                  disableLinkEdit={true}
                  editorData={
                    {
                      editorType: 'workShopBuyButton',
                      ...commonData
                    }
                  }
                />
               ) : ''
            }
          </Wrapper>
        </Wrapper>
      </Wrapper>
    );

  }

}

RedWorkshop.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
};

export default RedWorkshop;
